module.exports = __webpack_public_path__ + "img/work-with-06.4085708.png";